/**
 * @file initialData.js
 * @location src/data/initialData.js
 * @role 앱 초기 시드(Seed) 데이터 — localStorage 미존재 시 기본값으로 사용
 *
 * INIT_TASKS    초기 업무 목록
 *   task 구조: { id, title, status, priority, aee, aor, due }
 *   status:    'todo' | 'done'
 *
 * (일보 시드는 razor ⑱, ToDo 시드(INIT_TODOS)는 razor ㉑ 로 폐기.)
 */

// 시드 task createdAt — 모듈 평가 시점(=첫 진입) 기준 「N일 전 발신」 으로 보이도록.
// 짧은 id 'tN' 은 taskCreatedAtISO 의 epoch fallback 을 트리거 → 「20606일 전 발신」 폭주.
// createdAt 명시로 fallback 회피.
const ago = (days) => new Date(Date.now() - days * 86400000).toISOString();

export const INIT_TASKS = [
  { id: 't1',  title: '3분기 영업 기획안 작성',       status: 'done',   priority: 'normal', aee: 'm3', aor: 'm1', due: '2025-05-22', createdAt: ago(7) },
  { id: 't2',  title: '거래처 B 상담 준비',           status: 'todo',   priority: 'urgent', aee: 'm4', aor: 'm2', due: '2025-05-22', createdAt: ago(3) },
  { id: 't3',  title: '주차 보고서 정리',             status: 'todo',   priority: 'normal', aee: 'm3', aor: 'm1', due: '2025-05-22', createdAt: ago(5) },
  { id: 't4',  title: '고객 문의 대응 (CS-441)',      status: 'done',   priority: 'normal', aee: 'm4', aor: 'm2', due: '2025-05-22', createdAt: ago(7) },
  { id: 't5',  title: '신규 거래처 리서치',           status: 'todo',   priority: 'low',    aee: 'm2', aor: 'm1', due: '2025-05-22', createdAt: ago(4) },
  { id: 't7',  title: '2분기 실적 정리',              status: 'todo',   priority: 'urgent', aee: 'm6', aor: 'm5', due: '2025-05-31', createdAt: ago(2) },
  { id: 't8',  title: '사내 시스템 고도화 프로젝트',   status: 'todo',   priority: 'normal', aee: 'm7', aor: 'm5', due: '2025-08-31', createdAt: ago(6) },
  { id: 't9',  title: '채용 면접 일정 조율',          status: 'todo',   priority: 'normal', aee: 'm9', aor: 'm8', due: '2025-05-26', createdAt: ago(3) },
  { id: 't10', title: '복리후생 제도 개선',           status: 'todo',   priority: 'low',    aee: 'm8', aor: 'm8', due: '2025-06-30', createdAt: ago(4) },
];
